module.exports = __webpack_public_path__ + "static/media/portfolio1 (45).27acdaa4.jpeg";